import { environment } from '../../../environments/environment.local';

export const clientRateUriTemplate = (clientRateId?: string | number): string => {
  return `${environment.API.CLIENT_RATES_URI}/${clientRateId}`;
};
